<template lang="pug">
  model-form(
        ref="form"
        :editable="false"
        switchEdit
        reset-text="limpiar"
        submit-text="Editar"
        title="Editar Promoción"
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from './fields'
/* vuex */
import {mapActions} from 'vuex'
/* model */
import PromoModel from '@/models/Warehouse/WhPromo'
/* services */
import Translator from '@/services/translator'
import BranchOfficeService from '@/services/api/branchOffice'
export default {
  name: 'inventory-information',
  props: {
    dataProduct:{
      type: Object,
      required: true,
    },
    product:{
      type: Object,
    },
    updateComponent:{
      type: Boolean,
      default: false,
    },
  },
  data: function(){
    return {
      formData: {},
      formFields: FieldsCreate,
      loadedProduct: false,
    }
  },
  // computed: {},
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    submit() {
      this.$refs.form.setWait(true).then(this.update)
    },
    /*
     */
    update(data) {
     
      let model = new PromoModel({id:data.id})
      model.sync(this.formatData(data))
      .then(r=>this.successUpdate(r))
      //.then(this.redirectTo(data))
      .catch(this.error)
      .then(this.$refs.form.setWait)
      
    },
    formatData(data){
      let branch  = [...data.branch_offices]
      let format = branch.map(b=>{
        let priceOffice =data.sale_prices.find(sp=>sp.branch_office_id === b.g_branch_office_id)
        b.sale_price = priceOffice.sale_price
        return b
        // console.log(data.sale_prices,'sale_prices')
      })
    let branchWithStock =  format.map(b=>{
        let stockBranch = data.branch_office_selected.find(bs=> bs.id === b.g_branch_office_id)
        b.critical_stock = stockBranch.critical_stock
        b.maximum_stock = stockBranch.maximum_stock
        b.minimum_stock = stockBranch.minimum_stock
        return b
      })

      data.branch_office_data = branchWithStock
      data.products = this.formatProductsArray(data.products)
      
      return data
    },
    /*
     */
    formatProductsArray(products){
      return products.map(p=>{
        let newProd = {...p}
        newProd.wh_product_id = p.id
        return newProd
      })
    },
    /*
     */
    successUpdate(info) {
      this.$emit('productEdited')
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información Inventario editado exitosamente',
          timeout: 3000,
      })
    },
    error(error) {
    
      this.setSnackbar({
          type: 'error',
          title: 'Error',
          message: Translator(PromoModel, error.response.data),
          timeout: 15000,
      })
    },
    resetForm() {
        this.formData = {}
        this.formFields[0].props.items = []
    },
    setFormData: async function(model) {
      console.log(model,'model heeeee')
      model.branch_office_selected = await this.setStocksBranchOffice(model)
      this.formData = {...model}
      // this.formData.uom_quantity = parseInt(model.wh_item.uom_quantity)
      // this.formData.wh_unit_of_measurement_id = model.wh_item.wh_unit_of_measurement_id
      // this.formData.have_decimal_quantity = model.wh_item.have_decimal_quantity
      // this.formData.is_inventoriable = model.wh_item.is_inventoriable
      this.formData.is_repackaged = model.is_repackaged
      this.formData.is_seasonal = model.is_seasonal

    },
    async setStocksBranchOffice(model) {
      console.log(model,'product')
      let branch = await BranchOfficeService.fetchAll()
      console.log(branch,'branch')
      console.log(this.formData,'formdata')
      
      return branch.map(b=>{
        let auxBranch = model.branch_offices.find(branch => branch.g_branch_office_id === b.id )
        b.maximum_stock = parseInt(auxBranch.maximum_stock)
        b.minimum_stock = parseInt(auxBranch.minimum_stock)
        b.critical_stock = parseInt(auxBranch.critical_stock)
        return b
      })
    },
    // -- Validations and Error handling
    // -- Other functions
    redirect(){
      this.$router.push('/products')
    },
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
  },
  watch: {
    dataProduct(val){
      if(val && this.loadedProduct===false){
        this.setFormData(this.dataProduct)
        this.loadedProduct = true
      }
    },
    updateComponent(val){
      if(val){
        this.loadedProduct = false
      }
    }
  },
  components: {
    'model-form' : ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  beforeMounted(){
    //this.setFormData(this.dataProduct)
    //alert('aki')
    // let branch = await BranchOfficeService.fetchAll()
    // console.log(branch,'branch')
    // console.log(this.formData,'formdata')
    // this.formData.branch_office_selected = branch.map(b=>{
    //   b.maximum_stock =4
    //   b.minimum_stock =2
    //   b.critical_stock =3
    //   return b
    // })
    //this.formData =[...this.formData]
      
    
  }
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>